import { locationRoute } from "@/App";
import { useLocation } from "@/providers/LocationContextProvider";
import { parseAsBoolean, useQueryState } from "nuqs";
import { useMemo } from "react";
import { useTables } from "./useTables";
import { useRouterState } from "@tanstack/react-router";

export const useModeSelect = () => {
  const { locationId } = locationRoute.useParams();
  if (!locationId) {
    throw new Error("Location ID is required to use useModeSelect");
  }
  const router = useRouterState();
  const isWithinMenu = router.matches.find(
    (match) => match.fullPath === "/$locationId/$menuId/"
  );

  const { tableId, orderType, setTableId } = useLocation();

  const { data: tables } = useTables(locationId, true);

  const selectedTable = useMemo(() => {
    return tables?.find((table) => table.id === tableId);
  }, [tables, tableId]);

  const shouldBeOpen = useMemo(() => {
    if (!isWithinMenu) {
      //console.log("should mode select be open: false, not within menu yet");
      return false;
    }

    if (orderType === "TAKE_AWAY") {
      console.log("should mode select be open: false, orderType is TAKE_AWAY");
      return false;
    }

    if (orderType === "DELIVERY") {
      //console.log("should mode select be open: false, orderType is DELIVERY");
      return false;
    }

    if (tableId && !selectedTable) {
      // console.log(
      //   "should mode select be open: false, setting tableId",
      //   tableId
      // );
      setTableId(tableId);
      return false;
    }

    if (selectedTable?.id) {
      // console.log(
      //   "should mode select be open, false, already selected table:",
      //   selectedTable
      // );
      return false;
    }

    //console.log("should mode select be open: true, no table to select");
    return true;
  }, [orderType, selectedTable]);

  const [showSelector, setShowSelector] = useQueryState(
    "showModeSelector",
    parseAsBoolean.withDefault(shouldBeOpen)
  );

  return { showSelector, setShowSelector };
};
